import { AdjustmentStatus } from "../enums/adjustment-status.enum";
import { TransactionAdjustmentType } from "../enums/adjustment-type.enum";

export interface ITransactionAdjustment {
    id:string,
    amount:number;
    type: TransactionAdjustmentType; 
    reason: string;
    disputeId: string;
    chargebackId: string;
    brandClaimId: string;
    status: AdjustmentStatus;
}

export class TransactionAdjustment implements ITransactionAdjustment {
    id: string;
    amount: number;
    type: TransactionAdjustmentType;
    reason: string;
    disputeId: string;
    chargebackId: string;
    brandClaimId: string;
    status: AdjustmentStatus;

    constructor(
      id: string,
      amount: number,
      type: TransactionAdjustmentType,
      reason: string,
      disputeId: string,
      chargebackId: string,
      brandClaimId: string,
      status: AdjustmentStatus
    ) {
        this.id = id;
        this.amount = amount;
        this.type = type;
        this.reason = reason;
        this.disputeId = disputeId;
        this.chargebackId = chargebackId;
        this.brandClaimId = brandClaimId;
        this.status = status;
    }
}

